import React from 'react';
import styles from '../../styles/modules/components/protection-plan-card.module.scss';
import Button from '../common/ui-components/input/Button';
import {getUtmString, combineParamsString} from '../../utils';

interface ItemsProps {
    title: string,
    url: string,
    data: any,
    colomn?: any,
    router: any,
}



const ProtectionPlanCard = (props: ItemsProps) => {
    return (
        <div className={`col-12 col-md-12 ${props.colomn ? 'col-lg-6' : 'col-lg-4'}`}>
            <div className={` ${styles.contains}`}>
                <div className={` ${styles.card}`}>
                    <h2 className={`${styles._text} `}>{props.title}</h2>
                    <ul>
                        {props.data.map((info, index) => {
                            return <li key={index}>{info.brief}</li>
                        })}
                    </ul>
                    <Button className={styles.btn_submit} text="Explore Services" onClick={(e) => {
                        // Setting localStorage parameter for GTM
                        localStorage.setItem('journey_starts_from', 'protection grid')
                        e.preventDefault()
                        props.router.push(combineParamsString(`/${props.url}`, getUtmString()))
                    }}></Button>

                </div>

            </div>
        </div>
    )
}

export default ProtectionPlanCard
